module.exports = __webpack_public_path__ + "static/img/viral_29.fb4d99d3.jpeg";